<template>
    <div class="work-view">
    </div>
</template>

<script>
export default {
    name: 'search'
}
</script>